import React from 'react'
import { SanityQuoteList } from '../../../../../types/generated/graphql-types'
import { sanityQuoteToQuote } from '../../../../mapping/QuoteMapper'
import { notEmpty } from '../../../../utilities/filters'
import { QuoteSlideshowBox } from '../../../QuoteSlideshowBox'

export const QuoteListSerializer = ({ quotes }: SanityQuoteList): JSX.Element => (
  <QuoteSlideshowBox quotes={quotes?.filter(notEmpty)?.map(sanityQuoteToQuote) ?? []} />
)
